module.exports = __webpack_public_path__ + "img/dp-ld-an1.697cb9ee.png";